<div class="wrapper">
   <div class="container" style="--rating: {{ rating?.toFixed(1) }}">
     <div class="rating" [style.width.%]="rating * 20"></div>
     <div class="empty"></div>
   </div>
   <div>
     <span>{{rating?.toFixed(1)}} | {{reviews}} Reviews</span>
   </div>
 </div>